export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.6-2052.04",
  commitId: "2076c26336a07a63fc303abc85a6ddbeb52c38b0",
  commitTime: "2026-04-06T20:52:04.000Z",
});
